import { Injectable } from '@angular/core';
import { IDBPDatabase, IDBPTransaction, openDB, StoreNames } from 'idb';
import { User } from '@damofire/data-security';
import { UserClaims } from '@damofire/data-stas';

const IDB_AUTH_STORE = 'auth';
const IDB_AUTH_DATABASE = 'damofire-auth';
const IDB_AUTH_DATABASE_VERSION = 2;

export interface IdbUserToken {
  uid: string;
  user: User;
  claims: UserClaims;
}

@Injectable()
export class IdbAuthStoreService {
  private readonly db: Promise<IDBPDatabase>;

  constructor() {
    this.db = this.initDb();
  }

  private initDb(): Promise<IDBPDatabase> {
    return openDB(IDB_AUTH_DATABASE, IDB_AUTH_DATABASE_VERSION, {
      upgrade(database: IDBPDatabase, oldVersion: number, newVersion: number | null, transaction: IDBPTransaction<unknown, StoreNames<unknown>[], 'versionchange'>) {
        if (newVersion === 2) {
          if (!(transaction.objectStoreNames as unknown as DOMStringList).contains(IDB_AUTH_STORE)) {
            transaction.db.createObjectStore(IDB_AUTH_STORE, { keyPath: 'uid' });
          } else {
            transaction.db.clear(IDB_AUTH_STORE).catch(console.error);
          }
        }
      },
    });
  }

  async saveToken(uid: string, claims: UserClaims, user: User): Promise<void> {
    console.log(`IdbAuthStoreService - Storing user token.`, uid);
    const idb = await this.db;
    await idb.put(IDB_AUTH_STORE, { uid, claims, user });
  }

  async removeToken(uid: string): Promise<void> {
    console.log(`IdbAuthStoreService - Removing stored user token.`, uid);
    const idb = await this.db;
    await idb.delete(IDB_AUTH_STORE, uid);
  }

  async getToken(uid: string): Promise<IdbUserToken> {
    console.log(`IdbAuthStoreService - Resolving stored user token.`, uid);
    const idb = await this.db;
    return idb.get(IDB_AUTH_STORE, uid);
  }

  async close(): Promise<void> {
    (await this.db).close();
  }

  async clear(): Promise<void> {
    await (await this.db).clear(IDB_AUTH_STORE);
    return this.close();
  }
}
